/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { getRoute, mapRouteToRelativePath } from "./route-util";

export const ANY_ROUTE_NAME = "*";
export const ANY_ROUTE = mapRouteToRelativePath(ANY_ROUTE_NAME);

export const HOME_ROUTE_NAME = "home";
export const HOME_ROUTE = mapRouteToRelativePath(HOME_ROUTE_NAME);
export const HOME_ANY_ROUTE = getRoute(HOME_ROUTE_NAME, ANY_ROUTE_NAME);

export const LOGOUT_ROUTE_NAME = "logout";
export const LOGOUT_ROUTE = mapRouteToRelativePath(LOGOUT_ROUTE_NAME);

export const LOGOUT_CE_USER_ROUTE_NAME = "logout-ce-user";
export const LOGOUT_CE_USER_ROUTE = mapRouteToRelativePath(LOGOUT_CE_USER_ROUTE_NAME);
